module.exports = __webpack_public_path__ + "static/media/note upload.cb7ea956.svg";